import { Section } from "../components/sections/TextSection";
import { borderProps, commonProps, fontProps } from "./commonPropInfo";

export const optionSectionConfig: Section = {
    row: 0,
    col: 0,
    name: 'Options',
    type: 'option',
    id: '111',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    options: [{ label: 'Option 1', isCorrect: false, showLabel: true }],
    textContent: "",
    x: 0,
    y: 0,
    value: [],
    isLocked: false,
    propInfo: [
        ...commonProps,
        ...borderProps,
        ...fontProps,
        {
            name: 'gap',
            binding: '$options-grid.style.gap',
            inputType: 'number',
            value: '10px',
            label: 'Gap',
        },
        {
            name: "tags",
            inputType: 'tags',
            binding: 'options',
            options: [
                { label: 'Option 1', isCorrect: false, showLabel: false },
            ],
            value: [],
            label: 'Options',
        }
    ]
};
